import { AUTH_CUSTOMER_SERVICE, AUTH_HO_CS_LEADER } from 'constant/roles'
import { AUTH_ADMIN } from 'middleware/privateRoute'
import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import { ThreePLQuotaRolesRBAC } from '../pages/3PLQuotaPage/rbac'

const ThreePLQuota = lazy(() => import('../pages/3PLQuotaPage/3PLQuota'))

type NamedRoutesType = 'ThreePLQuotaRouter'
type PathListsType = '/dashboard/3plquota'

type RouterInstanceType = RouterFeatureInterface<NamedRoutesType, PathListsType>

const ThreePLQuotaRouterInstance: RouterInstanceType = {
  name: 'ThreePLQuotaRouter',
  Component: ThreePLQuota,
  path: '/dashboard/3plquota',
  routeType: 'PRIVATE',
  allowedRoles: [AUTH_ADMIN, AUTH_HO_CS_LEADER, AUTH_CUSTOMER_SERVICE, 'AUTH_CS_AGENT'],
  rbacPageID: ThreePLQuotaRolesRBAC.pageID,
  isDashboard: true,
}

const ThreePLQuotaRouter = [ThreePLQuotaRouterInstance]

export const ThreePLQuotaRouterDetail = generateRouterDetail(ThreePLQuotaRouter)

export default ThreePLQuotaRouter
